/**
 * Get color based on percentage scale
 * Returns both hex color (for charts) and CSS class name (for LineIndicator)
 */
export const getColorByScale = (scale) => {
  if (scale > 75) {
    return { hex: '#6fb206', className: 'green' }
  } else if (scale > 50) {
    return { hex: '#1679d9', className: 'blue' }
  } else if (scale > 35) {
    return { hex: '#d9d61b', className: 'amber' }
  } else if (scale > 20) {
    return { hex: '#d94ac1', className: 'pink' }
  } else {
    return { hex: '#fc4e08', className: 'orange' }
  }
}

